/* ==========================================================================
   KL Withdrawal — EU right-of-withdrawal two-step form
   Talks to kallistia-app: POST /api/withdrawal/validate (step-1 live lookup)
   and POST /api/withdrawal (step-2 submit). Hardened against non-JSON
   responses (e.g. the Vercel WAF HTML block page on rate-limit).
   ========================================================================== */
(function () {
  'use strict';

  var VALIDATE_API = 'https://app.kallistia.com/api/withdrawal/validate';
  var SUBMIT_API = 'https://app.kallistia.com/api/withdrawal';

  var page = document.getElementById('klWdPage');
  if (!page) return;

  var steps = {
    1: document.getElementById('klWdStep1'),
    2: document.getElementById('klWdStep2'),
    3: document.getElementById('klWdStep3')
  };
  var dots = page.querySelectorAll('#klWdSteps .kl-wd-dot');

  var elName = document.getElementById('klWdName');
  var elEmail = document.getElementById('klWdEmail');
  var elOrder = document.getElementById('klWdOrder');
  var elDate = document.getElementById('klWdDate');
  var elReason = document.getElementById('klWdReason');
  var elLookup = document.getElementById('klWdLookup');
  var elError = document.getElementById('klWdError');
  var confirmBtn = document.getElementById('klWdConfirm');

  var submitting = false;

  // ── helpers ──────────────────────────────────────────────────────────────

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];

  // Format a server UTC ISO-8601 string for display. Derives from the server
  // value; never regenerates it. Falls back to the raw string if unparseable.
  function fmtUTC(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear() +
           ' at ' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ' UTC';
  }

  function stripHash(s) { return (s || '').replace(/^#/, '').trim(); }

  function looksLikeEmail(s) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s || ''); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // POST JSON and parse the response defensively. A WAF/edge block can return
  // an HTML body with a non-2xx status; JSON.parse would throw. We return a
  // uniform shape so callers never crash on that.
  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        if (text) { try { data = JSON.parse(text); } catch (e) { data = null; } }
        return { ok: res.ok, status: res.status, data: data, isJson: data !== null };
      });
    });
  }

  // ── step navigation ──────────────────────────────────────────────────────

  function go(n) {
    var k;
    for (k in steps) { if (steps[k]) steps[k].classList.toggle('active', +k === n); }
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('on', +dots[i].getAttribute('data-dot') <= n);
    }
    if (window.scrollTo) {
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    }
  }

  document.getElementById('klWdStart').addEventListener('click', function () { go(2); });
  document.getElementById('klWdBack').addEventListener('click', function () { go(1); });

  // ── live order lookup (validate) ───────────────────────────────────────────
  // Non-blocking reassurance: shows the matched order, or a soft "not found"
  // note. Never blocks submission (accept-and-flag policy is server-side).

  var lookupTimer = null;
  var lastLookupKey = '';

  function scheduleLookup() {
    var email = (elEmail.value || '').trim();
    var order = stripHash(elOrder.value);
    if (!looksLikeEmail(email) || !order) { return; }
    var key = email + '|' + order;
    if (key === lastLookupKey) { return; }
    if (lookupTimer) { clearTimeout(lookupTimer); }
    lookupTimer = setTimeout(function () { runLookup(email, order, key); }, 450);
  }

  function runLookup(email, order, key) {
    lastLookupKey = key;
    elLookup.innerHTML = '<div class="kl-wd-lookup-note">' +
      '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>' +
      'Looking up your order...</div>';

    postJSON(VALIDATE_API, { email: email, orderNumber: order }).then(function (resp) {
      // Ignore if inputs changed since this lookup started.
      if (key !== lastLookupKey) { return; }
      if (!resp.ok || !resp.isJson) { elLookup.innerHTML = ''; return; } // silent on errors
      if (resp.data && resp.data.found && resp.data.order) {
        renderSummary(resp.data.order);
      } else {
        renderNotFound();
      }
    }).catch(function () {
      if (key === lastLookupKey) { elLookup.innerHTML = ''; }
    });
  }

  function renderSummary(order) {
    var items = '';
    if (order.items && order.items.length) {
      for (var i = 0; i < order.items.length; i++) {
        var it = order.items[i];
        items += '<div class="kl-wd-summary-item">' + esc(it.title) +
                 (it.quantity ? ' &times; ' + esc(it.quantity) : '') + '</div>';
      }
    }
    var meta = '';
    if (order.placedAt) {
      var d = new Date(order.placedAt);
      if (!isNaN(d.getTime())) {
        meta = 'Placed ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
      }
    }
    elLookup.innerHTML = '<div class="kl-wd-summary">' +
      '<div class="kl-wd-summary-head">' +
        '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
        'We found order ' + esc(order.orderName || ('#' + order.orderNumber)) +
      '</div>' + items +
      (meta ? '<div class="kl-wd-summary-meta">' + meta + '</div>' : '') +
    '</div>';
  }

  function renderNotFound() {
    elLookup.innerHTML = '<div class="kl-wd-lookup-note">' +
      '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>' +
      'We could not match these details to an order. Double-check them, or continue anyway and our team will review it.</div>';
  }

  elEmail.addEventListener('blur', scheduleLookup);
  elOrder.addEventListener('blur', scheduleLookup);
  elOrder.addEventListener('change', scheduleLookup);

  // ── submit (withdrawal declaration) ────────────────────────────────────────

  function clearFieldErrors() {
    elError.textContent = '';
    var inv = steps[2].querySelectorAll('.kl-wd-invalid');
    for (var i = 0; i < inv.length; i++) { inv[i].classList.remove('kl-wd-invalid'); }
  }

  function showError(msg, fieldEl) {
    elError.textContent = msg;
    if (fieldEl) { fieldEl.classList.add('kl-wd-invalid'); fieldEl.focus(); }
  }

  function setLoading(on) {
    submitting = on;
    confirmBtn.disabled = on;
    confirmBtn.classList.toggle('is-loading', on);
  }

  confirmBtn.addEventListener('click', function () {
    if (submitting) { return; }
    clearFieldErrors();

    var name = (elName.value || '').trim();
    var email = (elEmail.value || '').trim();
    var order = stripHash(elOrder.value);

    if (!name) { return showError('Please enter your full name.', elName); }
    if (!looksLikeEmail(email)) { return showError('Please enter the email address on your order.', elEmail); }
    if (!order) { return showError('Please enter your order number.', elOrder); }

    // Return-cost responsibility is disclosed in Step 1; proceeding past it is
    // the acknowledgement, so this is always true (no gating checkbox).
    var payload = {
      name: name,
      email: email,
      orderNumber: order,
      acknowledgedReturnCost: true
    };
    if (elDate.value) { payload.deliveryDate = elDate.value; }
    if ((elReason.value || '').trim()) { payload.reason = elReason.value.trim(); }

    setLoading(true);

    postJSON(SUBMIT_API, payload).then(function (resp) {
      setLoading(false);

      // Success.
      if (resp.ok && resp.data && resp.data.ok) {
        renderConfirmation(resp.data, order);
        go(3);
        return;
      }

      // True rate-limit (in-code limiter returns 429 JSON; WAF may 429 HTML).
      if (resp.status === 429) {
        showError('We are receiving a lot of requests right now. Please wait a moment and try again.');
        return;
      }

      // Structured error from the API (validation / 500 write-failed / 403).
      if (resp.isJson && resp.data && resp.data.error) {
        var fieldEl = null;
        if (resp.data.field === 'email') { fieldEl = elEmail; }
        else if (resp.data.field === 'orderNumber') { fieldEl = elOrder; }
        else if (resp.data.field === 'name') { fieldEl = elName; }
        showError(resp.data.error, fieldEl);
        return;
      }

      // Non-JSON error body (edge/WAF block page, 404, 5xx) or anything else:
      // the declaration was NOT recorded, so tell them to retry.
      showError('Something went wrong and your request was not submitted. Please try again in a moment.');
    }).catch(function () {
      setLoading(false);
      showError('We are having trouble connecting. Please try again in a moment.');
    });
  });

  function renderConfirmation(data, orderInput) {
    document.getElementById('klWdConfEmail').textContent = data.emailSentTo || elEmail.value.trim();
    document.getElementById('klWdConfRef').textContent = data.reference || '-';
    var ord = stripHash(orderInput);
    document.getElementById('klWdConfOrder').textContent = ord ? ('#' + ord) : '-';
    document.getElementById('klWdConfTime').textContent = fmtUTC(data.receivedAt) || '-';
  }

})();
